import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Col, DatePicker, Flex, Form, Input, InputNumber, Row, Select, Space, Table, Tabs, Tag, Tooltip, message } from 'antd';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { Badge } from 'flowbite-react';
import dayjs from 'dayjs';
import StatusComponent from '../../globalComponents/StatusComponent';
import EditableTable from '../../globalComponents/EditableTable';
import SmartButton from '../../globalComponents/SmartButton';
import { TbTruckDelivery } from "react-icons/tb";
import usePosOrderAPI from '../apis/posOrderAPI';
import formatAmount from '../../utils/formatAmount';

const productColumn = [
  {
    title: 'Product',
    dataIndex: 'product',
    editable: false,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    editable: false,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
  },
  {
    title: 'Price',
    dataIndex: 'price',
    editable: false,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
  },
  {
    title: 'Discount',
    dataIndex: 'discount',
    editable: false,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
  },
  {
    title: 'Taxes',
    dataIndex: 'tax',
    editable: false,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
  },
  {
    title: 'Subtotal',
    dataIndex: 'subtotal',
    editable: false,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
  },
];

const paymentColumn = [
  {
    title: 'Date',
    dataIndex: 'date',
    editable: false,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
  },
  {
    title: 'Payment Method',
    dataIndex: 'payment',
    editable: false,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    editable: false,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
  },
]


const PosOrderChanges = () => {
  const [form] = Form.useForm();
  const { success, error, CustomBreadcrumb } = useOutletContext();
  const posOrder = useLoaderData();
  const params = useParams();
  const navigate = useNavigate();

  console.log(posOrder)
  
  return (
    <div className='container mx-auto' style={{ maxWidth: '1200px' }}>
      <div>
        <div className='flex'>
          <h3 className='font-bold'>
            <CustomBreadcrumb />
            <Link to={'/pos/pos-orders'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Pos Orders</Link> / {params.action}
          </h3>
        </div>
        

      </div>
      <div className='mt-5 bg-white shadow'>
        {posOrder.status === 'paid' && <Flex className='border-b m-0' justify='flex-end'>
          <SmartButton icon={<TbTruckDelivery size={'1.4rem'} />} number={'Pickings'} className='border-s-2' />
        </Flex>}
        <Form
          form={form}
          className='p-3'
          labelAlign='left'
          labelCol={{ span: 7 }}
          initialValues={posOrder.reference ? posOrder : {} }
          variant='borderless'
          disabled={(posOrder.status === 'paid' || posOrder.status === 'posted') ? true : false}
        >
          <Row className='mb-4'>
            <Col md={{ span: 11 }}>
              <Form.Item label={'Order Ref'} name={'reference'} className='font-bold mb-1' required>
                <Input type='text' readOnly className='font-normal input-outline-none' />
              </Form.Item>
              <Form.Item label='Date' name={'date'} className='font-bold mb-1' required>
                <Input type='text' className='font-normal input-outline-none w-full' />
              </Form.Item>
              <Form.Item label={'Cashier'} name={'cashier'} className='font-bold mb-1' required>
                <Input type='text' readOnly className='font-normal input-outline-none' />
              </Form.Item>
              <Form.Item label={'Customer'} name={'customer'} className='font-bold mb-1' required>
                <Input type='text' readOnly className='font-normal input-outline-none' />
              </Form.Item>
            </Col>
            <Col md={{ span: 11, offset: 1 }}>
              <Form.Item label='Is Refund' name={'is_refund'} className='font-bold mb-1' valuePropName='checked' required>
                <Checkbox />
              </Form.Item>
              <Form.Item label='Session' name={'session'} className='font-bold mb-1' required>
                <Input type='text' className='font-normal input-outline-none' />
              </Form.Item>
            </Col>
          </Row>
          <Tabs
            type='card'
            items={[
              {
                key: 1,
                label: 'Products',
                children:
                  <>
                    <Table
                      columns={productColumn}
                      dataSource={posOrder.products}
                      pagination={false}
                    />
                    <div className='mt-4'>
                      <div className='flex justify-end w-full'>
                        <p className='me-3'>Subtoal: </p>
                        <span style={{width: '16%', fontWeight:'bold'}}>GHc {formatAmount(posOrder.totalOrder)}</span>
                      </div>
                      <div className='flex justify-end w-full'>
                        <p className='me-3'>Tax: </p>
                        <span style={{width: '16%', fontWeight:'bold'}}>GHc {formatAmount(posOrder.taxTotal)}</span>
                      </div>
                      <div className='flex justify-end w-full'>
                        <p className='me-3'>Total: </p>
                        <span style={{width: '16%', fontWeight:'bold'}}>GHc {formatAmount(posOrder.taxTotal*1 + posOrder.totalOrder*1)}</span>
                      </div>
                    </div>
                  </>
              },
              {
                key: '2',
                label: 'Payments',
                forceRender: true,
                children:
                  <>
                    <Table
                      columns={paymentColumn}
                      dataSource={posOrder.payments}
                      pagination={false}
                    />
                    
                  </>
              },
              {
                key: '3',
                label: 'Extra Information',
                forceRender: true,
                children:
                  <>
                    <Row>
                      <Col md={{ span: 11 }}>
                        <Badge className="text-slate-500 text-sm bg-transparent	border-b-2 mb-3">Other Information</Badge>
                        <Form.Item label='Receipt Number' name={'receipt_number'} className='font-bold mb-1' required>
                          <Input type='text' readOnly className='font-normal input-outline-none' />
                        </Form.Item>
                        <Badge className="text-slate-500 text-sm bg-transparent	border-b-2 mb-3">Loyal Programs</Badge>
                        <Form.Item label='Loyalty Points' className='font-bold mb-1'>
                          <InputNumber readOnly className='font-normal input-outline-none' />
                        </Form.Item>
                        <Badge className="text-slate-500 text-sm bg-transparent	border-b-2 mb-3">Refund</Badge>
                        <Form.Item label='Refund Reason' name={'refund_reason'} className='font-bold mb-1'>
                          <Input type='text' readOnly className='font-normal input-outline-none' />
                        </Form.Item>
                      </Col>
                      
                    </Row>
                  </>
              },
            ]}
          />
        </Form>
      </div>
    </div>
  )
}
export default PosOrderChanges;